<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'roleMenuList' }">角色菜单管理</router-link>
                </li>
                <li class="active">(添加菜单)</li>
            </ol>
        </div>
        <div class="content-from">
            <form class="form-horizontal">
                <div class="form-group">
                    <label class="col-sm-2 control-label">角色名称</label>
                    <div class="col-sm-4">
                        <input type="text" v-model="saveModel.name" placeholder="角色名称" class="form-control" name="name" v-validate="'required'" :class="{ 'validate-input': true, 'is-danger': errors.has('name') }">
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-sm-2 control-label">角色级别</label>
                    <div class="col-sm-4">
                        <input type="number" v-model="saveModel.level" placeholder="级别" class="form-control" name="level" v-validate="'required'" :class="{ 'validate-input': true, 'is-danger': errors.has('level') }">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-4 col-sm-offset-2">
                        <button v-on:click="saveRole" type="button" class="btn btn-info">确认</button>
                        <button type="button" class="btn btn-default" @click="$router.back(-1)">取消</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            roleId: '',
            saveModel: {

            },
        }
    },
    created() {
        var _this = this;
        _this.roleId = _this.$route.query.roleId;
        if (_this.roleId) {
            _this.detailRole();
        }
    },
    methods: {
        detailRole() {
            var _this = this;
            _this.$common.my_ajax({
                url: 'role/detailRole',
                data: {
                    roleId: _this.roleId
                },
                success: function(response) {
                    if(response.item){
                      _this.saveModel = response.item;
                    }
                }
            });
        },
        saveRole() {
            var _this = this;
            _this.$validator.validateAll().then((result) => {
                if (result) {
                    _this.$common.my_ajax({
                        url: 'role/saveRole',
                        data: _this.saveModel,
                        success: function(response) {
                            _this.$message({
                                message: '保存成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function() {
                                 _this.$router.push({ name: 'roleList' });
                                }
                            });
                        }
                    });
                }
            });
        }
    },
}
</script>
<style scoped>
</style>